import React from 'react';
import { 
  Bold, Italic, Heading1, Heading2, Heading3, 
  List, ListOrdered, Link as LinkIcon, Image,
  Code, Quote, Minus
} from 'lucide-react';

interface EditorToolbarProps {
  onInsert: (text: string) => void;
}

export const EditorToolbar: React.FC<EditorToolbarProps> = ({ onInsert }) => {
  const insertFormat = (format: string) => {
    onInsert(format);
  };

  const handleLinkClick = () => {
    const url = prompt('הכנס כתובת URL:');
    const text = prompt('הכנס טקסט לקישור:');
    if (url && text) {
      onInsert(`[${text}](${url})`);
    }
  };

  const handleImageClick = () => {
    const url = prompt('הכנס כתובת URL של התמונה:');
    const alt = prompt('הכנס טקסט חלופי לתמונה:');
    if (url && alt) {
      onInsert(`![${alt}](${url})`);
    }
  };

  return (
    <div className="flex flex-wrap gap-2 p-2 bg-gray-50 rounded-t-lg border-b" dir="ltr">
      <button
        type="button"
        onClick={() => insertFormat('**טקסט מודגש**')}
        className="p-2 hover:bg-gray-200 rounded"
        title="טקסט מודגש"
      >
        <Bold className="w-5 h-5" />
      </button>
      
      <button
        type="button"
        onClick={() => insertFormat('*טקסט נטוי*')}
        className="p-2 hover:bg-gray-200 rounded"
        title="טקסט נטוי"
      >
        <Italic className="w-5 h-5" />
      </button>

      <div className="w-px h-8 bg-gray-300 mx-1 self-center" />

      <button
        type="button"
        onClick={() => insertFormat('\n# כותרת ראשית\n')}
        className="p-2 hover:bg-gray-200 rounded"
        title="כותרת ראשית"
      >
        <Heading1 className="w-5 h-5" />
      </button>

      <button
        type="button"
        onClick={() => insertFormat('\n## כותרת משנית\n')}
        className="p-2 hover:bg-gray-200 rounded"
        title="כותרת משנית"
      >
        <Heading2 className="w-5 h-5" />
      </button>

      <button
        type="button"
        onClick={() => insertFormat('\n### כותרת קטנה\n')}
        className="p-2 hover:bg-gray-200 rounded"
        title="כותרת קטנה"
      >
        <Heading3 className="w-5 h-5" />
      </button>

      <div className="w-px h-8 bg-gray-300 mx-1 self-center" />

      <button
        type="button"
        onClick={() => insertFormat('\n- פריט ברשימה\n- פריט נוסף\n')}
        className="p-2 hover:bg-gray-200 rounded"
        title="רשימה"
      >
        <List className="w-5 h-5" />
      </button>

      <button
        type="button"
        onClick={() => insertFormat('\n1. פריט ראשון\n2. פריט שני\n')}
        className="p-2 hover:bg-gray-200 rounded"
        title="רשימה ממוספרת"
      >
        <ListOrdered className="w-5 h-5" />
      </button>

      <div className="w-px h-8 bg-gray-300 mx-1 self-center" />

      <button
        type="button"
        onClick={handleLinkClick}
        className="p-2 hover:bg-gray-200 rounded"
        title="הוסף קישור"
      >
        <LinkIcon className="w-5 h-5" />
      </button>

      <button
        type="button"
        onClick={handleImageClick}
        className="p-2 hover:bg-gray-200 rounded"
        title="הוסף תמונה"
      >
        <Image className="w-5 h-5" />
      </button>

      <div className="w-px h-8 bg-gray-300 mx-1 self-center" />

      <button
        type="button"
        onClick={() => insertFormat('\n```\nקוד כאן\n```\n')}
        className="p-2 hover:bg-gray-200 rounded"
        title="בלוק קוד"
      >
        <Code className="w-5 h-5" />
      </button>

      <button
        type="button"
        onClick={() => insertFormat('\n> ציטוט\n')}
        className="p-2 hover:bg-gray-200 rounded"
        title="ציטוט"
      >
        <Quote className="w-5 h-5" />
      </button>

      <button
        type="button"
        onClick={() => insertFormat('\n---\n')}
        className="p-2 hover:bg-gray-200 rounded"
        title="קו מפריד"
      >
        <Minus className="w-5 h-5" />
      </button>
    </div>
  );
};